export function exportFilenameSlug(value) {
	return String(value || '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
}

export function downloadBlob(blob, filename) {
	const url = URL.createObjectURL(blob)
	try {
		const link = document.createElement('a')
		link.href = url
		link.download = filename
		link.click()
	} finally {
		// Give the browser time to begin consuming the object URL.
		setTimeout(() => URL.revokeObjectURL(url), 1000)
	}
}
